/* eslint-disable react/function-component-definition */
import React, { useEffect, useRef } from 'react';
import { Tabs } from 'flowbite-react';          // ⬅️ quitamos TabsRef
import {
  BN100Card,
  IPTransitCard,
  SmartDispatchCard,
  XPTCard,
} from './SolutionCards';

function TabsSoluciones({ defaultKey = 'bn100' }) {
  const tabKeys = ['bn100', 'ip-transit', 'smartdispatch', 'xpt'];
  const tabsRef = useRef(null);                // ref sencillo, sin tipado

  // Selecciona la pestaña al montar / cuando cambia la URL
  useEffect(() => {
    const idx = tabKeys.indexOf(defaultKey.toLowerCase());
    if (idx >= 0) tabsRef.current?.setActiveTab(idx);
  }, [defaultKey]);

  return (
    <Tabs
      aria-label="Soluciones Hytera"
      variant="underline"
      ref={tabsRef}
      /* Si luego quieres sincronizar la URL al hacer click, descomenta:
      onActiveTabChange={(index) => {
        window.history.replaceState(null, '', `/soluciones/${tabKeys[index]}`);
      }}
      */
    >
      <Tabs.Item title="BN100">
        <BN100Card />
      </Tabs.Item>

      <Tabs.Item title="IP Transit">
        <IPTransitCard />
      </Tabs.Item>

      <Tabs.Item title="SmartDispatch Plus">
        <SmartDispatchCard />
      </Tabs.Item>

      <Tabs.Item title="XPT">
        <XPTCard />
      </Tabs.Item>
    </Tabs>
  );
}

export default TabsSoluciones;
